import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import { SegmentedControl } from '@/components/SegmentedControl';
import { useFormatText } from '@/hooks/useFormatText';
import usePageTitle from '@/hooks/usePageTitle';

import Games from './Games';
import Learning from './Learning';
import License from './License';
import OverView from './OverView';

const ReportAnalytics = () => {
  const { id } = useParams();
  const { formatText } = useFormatText();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<string>(
    id === 'overview'
      ? 'overview'
      : id === 'learning'
        ? 'learning'
        : id === 'games'
          ? 'games'
          : id === 'license-report'
            ? 'license-report'
            : 'overview'
  );

  useEffect(() => {
    if (id === 'overview') {
      setActiveTab('overview');
    } else if (id === 'learning') {
      setActiveTab('learning');
    } else if (id === 'games') {
      setActiveTab('games');
    } else if (id === 'license-report') {
      setActiveTab('license-report');
    }
  }, [id]);

  const { setTitle, setIsBreadcrumb } = usePageTitle();
  const pageTitle = formatText('report-analytics.title');

  useEffect(() => {
    document.title = pageTitle;
    setTitle(pageTitle);
    setIsBreadcrumb([{ label: pageTitle }]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageTitle]);

  const handleTabChange = (value: string) => {
    setActiveTab(value);
    navigate(`/report-analytics/${value}`);
  };

  return (
    <>
      <div className="mb-6 -mx-1 px-1 overflow-x-auto">
        <SegmentedControl
          value={activeTab}
          onChange={handleTabChange}
          variant="underline"
          className="w-max min-w-full"
          options={[
            {
              value: 'overview',
              label: formatText('report-analytics.tabs.overview'),
              disabled: false,
            },
            {
              value: 'learning',
              label: formatText('report-analytics.tabs.learning'),
              disabled: false,
            },
            {
              value: 'games',
              label: formatText('report-analytics.tabs.games'),
              disabled: false,
            },
            {
              value: 'license-report',
              label: formatText('report-analytics.tabs.license-report'),
              disabled: false,
            },
          ]}
        />
      </div>

      {activeTab === 'overview' && <OverView />}
      {activeTab === 'learning' && <Learning />}
      {activeTab === 'games' && <Games />}
      {activeTab === 'license-report' && <License />}
    </>
  );
};

export default ReportAnalytics;
